<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('shiftManagement.shift') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row mb-3">
            <div class="col-sm-12 col-lg-6 col-md-12">
              <div class="form-group row">
                <label class="col-md-5 form-col-label control-label required">
                  {{ $t('shiftManagement.shiftName') }}
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.shift_name"
                    type="text"
                    class="form-control kh-font"
                    :class="{ 'is-invalid': errors.has('shift_name') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('shift_name')">
                    {{ errors.first('shift_name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-5 form-col-label control-label required">
                  {{ $t('shiftManagement.shiftType') }}
                </label>
                <div class="col-md-7">
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('shift_type') }"
                    v-model="model.shift_type"
                  >
                    <option :value="null" disabled selected style="display: none;"> {{ $t('select') }}</option>
                    <option value="Normal">Normal</option>
                    <option value="Shift">Shift</option>
                    <option value="Rotation">Rotation</option>
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('shift_type')">
                    {{ errors.first('shift_type') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-5 form-col-label control-label required">
                  {{ $t('shiftManagement.minuteAllow') }}
                </label>
                <div class="col-md-7">
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="model.minute_allow"
                    :class="{ 'is-invalid': errors.has('minute_allow') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('minute_allow')">
                    {{ errors.first('minute_allow') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12">
            <div id="container-table">
              <table class="table ui-table table-hover">
                <thead>
                  <tr>
                    <th style="width:10%">
                      {{ $t('shiftManagement.keyword') }}
                    </th>
                    <th class="text-center">
                      {{ $t('shiftManagement.fromDay') }}
                    </th>
                    <th class="text-center">
                      {{ $t('shiftManagement.toDay') }}
                    </th>
                    <th style="width:15%" class="text-center">
                      {{ $t('shiftManagement.firstIn') }}
                    </th>
                    <th style="width:15%" class="text-center">
                      {{ $t('shiftManagement.firstOut') }}
                    </th>
                    <th style="width:15%" class="text-center">
                      {{ $t('shiftManagement.secondIn') }}
                    </th>
                    <th style="width:15%" class="text-center">
                      {{ $t('shiftManagement.secondOut') }}
                    </th>
                    <th style="width:12%">
                      {{ $t('shiftManagement.TotalHours') }}
                    </th>
                    <th style="width: 2%" class="text-center">
                      <a href="#" class="text-primary" v-tooltip="$t('tooltip.addItem')">
                        <i class="fa fa-plus" @click.prevent="addNewRow"></i>
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in model.details" :key="index">
                    <td>
                      <input
                        type="text"
                        :readonly="!requiredKeyword"
                        v-model="item.keyword"
                        class="form-control only-border-bottom"
                        :class="{
                          'is-invalid': errors.has('details.' + index + '.keyword')
                        }"
                      />
                      <div class="invalid-feedback" v-if="errors.has('details.' + index + '.keyword')">
                        {{ errors.first('details.' + index + '.keyword') }}
                      </div>
                    </td>
                    <td>
                      <ts-select
                        v-model="item.day_id_from"
                        :disabled="!requiredWeekDay"
                        class="form-control only-border-bottom"
                        :options="
                          weekDays.map(e => ({
                            text: e.day_name,
                            value: e.day_id
                          }))
                        "
                        :class="{
                          'is-invalid': errors.has('details.' + index + '.day_id_from')
                        }"
                      />
                      <div class="invalid-feedback" v-if="errors.has('details.' + index + '.day_id_from')">
                        {{ errors.first('details.' + index + '.day_id_from') }}
                      </div>
                    </td>
                    <td>
                      <ts-select
                        v-model="item.day_id_to"
                        :disabled="!requiredWeekDay"
                        class="form-control only-border-bottom"
                        :options="
                          weekDays.map(e => ({
                            text: e.day_name,
                            value: e.day_id
                          }))
                        "
                        :class="{
                          'is-invalid': errors.has('details.' + index + '.day_id_to')
                        }"
                      />
                      <div class="invalid-feedback" v-if="errors.has('details.' + index + '.day_id_to')">
                        {{ errors.first('details.' + index + '.day_id_to') }}
                      </div>
                    </td>
                    <td>
                      <ts-time-picker-input
                        :class="{
                          'is-invalid': errors.has('details.' + index + '.first_in')
                        }"
                        v-model="item.first_in"
                        @input="item.total_hour = totalHour(item).value"
                      />
                      <div class="invalid-feedback" v-if="errors.has('details.' + index + '.first_in')">
                        {{ errors.first('details.' + index + '.first_in') }}
                      </div>
                    </td>
                    <td>
                      <ts-time-picker-input
                        v-model="item.first_out"
                        @input="item.total_hour = totalHour(item).value"
                        :class="{
                          'is-invalid': errors.has('details.' + index + '.first_out')
                        }"
                      />
                      <div class="invalid-feedback" v-if="errors.has('details.' + index + '.first_out')">
                        {{ errors.first('details.' + index + '.first_out') }}
                      </div>
                    </td>
                    <td>
                      <ts-time-picker-input v-model="item.second_in" @input="item.total_hour = totalHour(item).value" />
                    </td>
                    <td>
                      <ts-time-picker-input
                        v-model="item.second_out"
                        @input="item.total_hour = totalHour(item).value"
                      />
                    </td>
                    <td>
                      <input hidden v-model.number="item.total_hour" />
                      <input :value="totalHour(item).description" class="form-control-plaintext" />
                    </td>
                    <td class="text-center">
                      <a
                        href="#"
                        class="text-danger"
                        v-tooltip="$t('tooltip.removeItem')"
                        @click.prevent="removeRow(item)"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 text-right">
            <ts-button class="btn-primary mr-2" @click.prevent="save" :waiting="saving" v-if="model.details.length">
              {{ $t('button.save') }}
            </ts-button>
            <ts-button
              outline
              color="primary"
              class="mr-2"
              @click.prevent="saveNew"
              :waiting="saving_new"
              v-if="model.details.length"
            >
              {{ $t('button.saveAddNew') }}
            </ts-button>
            <ts-button class="btn-default" @click="$router.push({ name: 'shift-management' })">
              {{ $t('button.cancel') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'shift-management-create',
  data() {
    return {
      model: {
        shift_name: '',
        shift_type: null,
        minute_allow: '',
        details: []
      },
      newRow: {
        record_id: 0,
        keyword: '',
        day_id_from: '',
        day_id_to: '',
        first_in: '',
        first_out: '',
        second_in: '',
        second_out: '',
        total_hour: ''
      },
      errors: new Errors(),
      saving: false,
      saving_new: false,
      weekDays: [
        {
          day_id: 1,
          day_name: 'Monday'
        },
        {
          day_id: 2,
          day_name: 'Tuesday'
        },
        {
          day_id: 3,
          day_name: 'Wednesday'
        },
        {
          day_id: 4,
          day_name: 'Thursday'
        },
        {
          day_id: 5,
          day_name: 'Friday'
        },
        {
          day_id: 6,
          day_name: 'Saturday'
        },
        {
          day_id: 7,
          day_name: 'Sunday'
        }
      ]
    }
  },
  computed: {
    requiredKeyword() {
      if (this.model.shift_type === 'Normal' || this.model.shift_type === 'Shift') {
        this.model.details.map(d => (d.keyword = ''))
        return false
      } else {
        return true
      }
    },

    requiredWeekDay() {
      if (this.model.shift_type === 'Rotation' || this.model.shift_type === 'Shift') {
        this.model.details.map(d => (d.day_id_from = d.day_id_to = ''))
        return false
      } else {
        return true
      }
    },

    ...mapGetters('hr/shiftManagement', ['totalHour'])
  },
  created() {},
  methods: {
    addNewRow() {
      this.model.details.push(_.clone(this.newRow))
    },
    removeRow(item) {
      this.model.details.splice(this.model.details.indexOf(item), 1)
    },

    save() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/shiftManagement/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'shift-management' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveNew() {
      this.errors = new Errors()
      this.saving_new = true
      this.$store
        .dispatch('hr/shiftManagement/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.saving_new = false
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput() {
      this.model = {
        shift_name: '',
        shift_type: null,
        minute_allow: '',
        details: []
      }
    }
  },
  watch: {},
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/shiftManagement/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
#container-table {
  border: 1px solid #EAECEE;
  min-height: 40vh;
	max-height: 50vh;
	overflow-y:scroll;
	overflow-x: hidden;
	scrollbar-width: none;
   -ms-overflow-style: none;
}
::-webkit-scrollbar {
		width: 3px;  /* Remove scrollbar space */
		background: transparent;  /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
		background: rgb(194, 194, 194);
}
	table td {
		vertical-align : middle;
	}
	.only-border-bottom {
		border-top: none;
		border-left: none;
		border-right: none;
		outline: none;
	}
	.table > thead > tr > th {
	  position: sticky;
		position: -webkit-sticky;
		top: 0;
		z-index: 2;
	}
	.table > tbody > tr > td{
		padding-top: 5px !important;
		padding-bottom: 5px !important;
    border: none !important;
	}
	#amountValue tr > td{
		padding: 5px;
	}
</style>
